import { useEffect } from 'react';
import { useQuery } from 'urql';

import { activeFavicon, WORKSPACES_QUERY, type WorkspacesData } from '@shared/hooks/use-workspaces';

const ICON_LINKS = 'link[rel~="icon"]';

export function applyFavicon(url: string, doc: Document = document): () => void {
  const head = doc.head;
  const replaced = Array.from(head.querySelectorAll<HTMLLinkElement>(ICON_LINKS));
  replaced.forEach((link) => {
    link.remove();
  });

  const link = doc.createElement('link');
  link.rel = 'icon';
  link.href = url;
  head.appendChild(link);

  return () => {
    link.remove();
    replaced.forEach((original) => {
      head.appendChild(original);
    });
  };
}

export function useTenantFavicon(): void {
  const [{ data }] = useQuery<WorkspacesData>({
    query: WORKSPACES_QUERY,
    requestPolicy: 'cache-first',
  });
  const url = activeFavicon(data);

  useEffect(() => {
    if (!url) return;
    return applyFavicon(url);
  }, [url]);
}
